export const THEME_MODES = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  TOKEN_EXPIRES_AT: 'token_expires_at',
  TEMP_TOKEN: 'temp_token',
  AI_ANALYST_CHAT_ID: 'aiAnalystCurrentChatId',
  AI_ANALYST_HISTORY: 'aiAnalystChatHistory',
  DARK_MODE: 'darkMode',
  SIDEBAR_COLLAPSED: 'sidebar_collapsed',
  LAST_ACTIVITY: 'last_activity',
  // Login-bundled /codenames payload, stashed by SignInPage just before the
  // post-login hard reload and consumed once by portfolioOptions on its next
  // module load (so the Portfolios list renders with zero post-login fetch).
  CODENAMES_PRELOAD: 'codenames_preload',
  // Authoritative "last business day with data" (MAX as_of_date), persisted from
  // the /codenames payload. Report date defaults read this instead of "yesterday"
  // so they never land on a weekend / holiday / no-data day.
  LATEST_DATA_DATE: 'latest_data_date',
  // The newest as-of date the report picker may OFFER, also from /codenames.
  // >= LATEST_DATA_DATE: the backend walks the snapshot date forward over closed
  // market days (it owns the holiday calendar; the client does not), so today's
  // own Saturday is selectable even though no Saturday snapshot exists.
  MAX_SELECTABLE_DATE: 'max_selectable_date',
  // The client most recently opened on the portfolio detail page, used to
  // autofill the report portfolio picker. Session-scoped (tab-only) and cleared
  // on logout - never written to localStorage so it can't bleed into the next
  // user's session on a shared machine.
  LAST_ACCESSED_PORTFOLIO: 'last_accessed_portfolio',
};

// Inactivity timeout in milliseconds (3 hours)
export const INACTIVITY_TIMEOUT_MS = 3 * 60 * 60 * 1000;

// Client families whose portfolio detail pages are warmed at login (matched
// against the /codenames payload case-insensitively, "@" affix ignored), so
// opening those tabs renders with zero fetch. "VOUCHSAFE1" is the primary Josh
// account - there is no bare "JOSH" codename.
export const PRELOAD_PORTFOLIO_CODENAMES = [
  'CLINT', 'ROSE', 'DAN1', 'DAN2', 'JOSH1',
  'DOUG', 'TYLER', 'CLIVE', 'PLANT', 'DINA',
];

export const REPORT_TYPES = {
  SECURITY_CROSS_REFERENCE: 'security_cross_reference',
  PORTFOLIO_SUMMARY: 'portfolio_summary',
  FIXED_INCOME_ANALYSIS: 'fixed_income_analysis',
  CUSTOM_REPORT: 'custom_report',
  ASSET_ALLOCATION: 'asset_allocation',
};

